import React from 'react'
import styled from 'styled-components'
import { GQLMedicationDispensing } from '@mdpp/common/lib/@types/server.schema'
import { ReservationNoticeLeft } from './ReservationNoticeLeft'

interface IReservationNoticeBoxProps {
  onClickCancel: () => void
  onClickFinish?: () => void
  reservation: GQLMedicationDispensing
}

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
  padding: 36px 0;
  gap: 10px;

  @media (min-width: 1024px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`

export const ReservationNoticeBox: React.FC<IReservationNoticeBoxProps> = props => {
  const { reservation } = props

  return (
    <Wrapper>
      <ReservationNoticeLeft reservation={reservation} />
    </Wrapper>
  )
}
